import React, { useEffect } from 'react'
import { useInputParametersUpdateScope } from '../hooks'
import { useUserTemplateConfigForm } from '../../../views/Setup/AIFeaturePresets/PresetConfig/Template/Hierarchy/hooks'
import { YesNoCancelModal } from '../../Modal/YesNoCancelModal'
import { TemplateBox } from '../../TemplateBox/TemplateBox'
import { Button } from '../../Button/Button'
import { InputParameterHierarchyType } from '../model'
import { TemplateInputParameters } from '../../../models/AiFeature'

interface MeetingTemplateGlobalTemplateConfigFormBodyProps {
  type: InputParameterHierarchyType
  typeId: string
  inputParametersSchema: { [key: string]: any } | undefined
  defaultInputParameters: TemplateInputParameters
  parentInputParameters: TemplateInputParameters
  inputParameters: TemplateInputParameters
  onSave: (inputParameters: TemplateInputParameters, isCustomized: boolean) => Promise<void>
  onHide: () => void
  updateLoading: boolean
  isCustomized: boolean
  showCustomizationSetting: boolean
  ipHierarchyEnabled: boolean
}

export const MeetingTemplateGlobalTemplateConfigFormBody: React.FC<MeetingTemplateGlobalTemplateConfigFormBodyProps> = ({
  typeId,
  defaultInputParameters,
  parentInputParameters,
  inputParameters,
  onSave,
  onHide,
  updateLoading,
  isCustomized,
  showCustomizationSetting,
}) => {
  const { hasIpHierarchyAdminScope } = useInputParametersUpdateScope()
  const disabled = !hasIpHierarchyAdminScope

  const {
    editedInputParameters,
    templateHasValue,
    isChanged,
    customized,
    showConfirmation,
    shouldReset,
    isGenerating,
    showGenerate,
    setEditedInputParameters,
    setShouldReset,
    setShowConfirmation,
    handleChangeCustomized,
    handleChangeTemplate,
    handleClickBack,
    handleClickCancel,
    handleClickSave,
    checkForChange,
  } = useUserTemplateConfigForm(inputParameters, parentInputParameters, isCustomized, onSave, onHide, disabled)

  useEffect(() => {
    checkForChange()
    setShouldReset(false)
  }, [checkForChange])

  return (
    <>
      <YesNoCancelModal
        show={showConfirmation}
        onHide={() => setShowConfirmation(false)}
        message={'Do you want to save your changes?'}
        onYes={() => {
          onSave(editedInputParameters, customized)
          onHide()
        }}
        onNo={() => {
          setEditedInputParameters(inputParameters)
          onHide()
        }}
      />
      <TemplateBox
        shouldShowGenerate={true}
        onGenerate={() => {}}
        template={inputParameters.template}
        defaultTemplate={defaultInputParameters.template}
        parentTemplate={parentInputParameters.template}
        generatedTemplate={''}
        onChangeTemplate={handleChangeTemplate}
        customized={customized}
        onChangeCustomized={handleChangeCustomized}
        showCustomizationSetting={showCustomizationSetting}
        shouldReset={shouldReset}
        disabled={disabled}
        typeId={typeId}
      />
      <div className='d-flex justify-content-between w-100 mt-3'>
        <Button variant='borderless' onClick={handleClickBack}>
          {showGenerate ? 'Back' : 'Close'}
        </Button>
        {hasIpHierarchyAdminScope && (
          <div className='d-flex gap-2'>
            <Button variant='secondary' onClick={handleClickCancel} disabled={!isChanged} loading={updateLoading || isGenerating}>
              Cancel
            </Button>
            <Button variant='primary' onClick={handleClickSave} disabled={!isChanged || !templateHasValue} loading={updateLoading || isGenerating}>
              Save
            </Button>
          </div>
        )}
      </div>
    </>
  )
}
